import { Button, Grid2, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from 'dayjs';
import config from '../../config/config.js';
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import { CSVLink } from "react-csv";

const Tab3Details = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const serverUrl = config.serverUrl;
    const token = localStorage.getItem('token');
    const dateFromState = location.state?.dateFilterTab3;
    const sessionId = location.state?.sessionId;
    const [rows,setRows] = useState([]);
    const [orderBy, setOrderBy] = useState('stop_order_id');
    const [order, setOrder] = useState('asc');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const utcOffset = parseInt(localStorage.getItem('utc_offset') || '330', 10);
    const timeZoneFormat = localStorage.getItem('time_zone_format') || '12';

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    console.log('dateFromState', dateFromState);
    console.log('sessionId', sessionId);

    const fetchDetails = async() => {
        try {
            const url = serverUrl + `/shuttle/fetch_active_sessions`;
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                date: dateFromState,
                session_id: sessionId,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                const driverTrips = response.data;
                console.log('driverTrips', driverTrips);
                setRows(driverTrips);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }
    
    const exportData = rows.map(row => ({
        ...row,
        stop_status: `${row.stop_status?.toUpperCase() || ''}${
            row.is_auto_arrived ? ' (Auto)' : ''
        }`
    }));
    // Comparator based on current order and column
    const getComparator = (ord, key) => {
        return (a, b) => {
            let va = a?.[key];
            let vb = b?.[key];

            if (key === 'stop_order_id') {
                va = Number(va) || 0;
                vb = Number(vb) || 0;
            } else if (key === 'punch_time') {
                va = va ? new Date(va).getTime() : 0;
                vb = vb ? new Date(vb).getTime() : 0;
            } else {
                va = (va ?? '').toString().toLowerCase();
                vb = (vb ?? '').toString().toLowerCase();
            }

            if (va < vb) return ord === 'asc' ? -1 : 1;
            if (va > vb) return ord === 'asc' ? 1 : -1;
            return 0;
        };
    };

    const sortedRows = useMemo(() => {
        if (!Array.isArray(rows)) return [];
        const cmp = getComparator(order, orderBy);
        return [...rows].sort(cmp);
    }, [rows, order, orderBy]);

    const paginatedRows = useMemo(() => {
        const start = page * rowsPerPage;
        const end = start + rowsPerPage;
        return sortedRows.slice(start, end);
    }, [sortedRows, page, rowsPerPage]);

    useEffect(() => {
        fetchDetails(dateFromState, sessionId);
    },[])

    const headers = [
        { label: 'Stop ID', key: 'stop_id' },
        { label: 'Stop Name', key: 'name' },
        { label: 'Stop Status', key: 'stop_status' },
        { label: 'Punch Time', key: 'punch_time' },
        { label: 'Address', key: 'address' },
        { label: 'Latitude', key: 'latitude' },
        { label: 'Longitude', key: 'longitude' }
    ];
    
    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Trip Details
            </Typography>

            <Grid2 container>
                <Grid2 item sx={{marginLeft:'auto'}}>
                    <Button variant='contained' style={{width: '120px', height: '44px', backgroundColor:'#36C68F', textTransform:'none', borderRadius:'8px',marginLeft:'auto'}}> 
                        <CSVLink
                            data={exportData}
                            headers={headers}
                            filename={"TripDetails.csv"}
                            style={{ textDecoration: 'none' }}
                        > 
                            <Typography sx={{color: '#fff'}}>Export CSV</Typography>
                        </CSVLink>
                    </Button>
                </Grid2>
            </Grid2>

            <TableContainer className="table-container" sx={{maxHeight:'74vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Stop ID</TableCell>
                            <TableCell align="center" className="table-header" style={{minWidth:'120px' }}>
                                <TableSortLabel
                                    active={orderBy === 'name'}
                                    direction={orderBy === 'name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('name')}
                                >
                                    Stop Name
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{minWidth:'180px'}}>
                                <TableSortLabel
                                    active={orderBy === 'stop_status'}
                                    direction={orderBy === 'stop_status' ? order : 'asc'}
                                    onClick={() => handleRequestSort('stop_status')}
                                >
                                    Stop Status
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ minWidth:'180px' }}>
                                <TableSortLabel
                                    active={orderBy === 'punch_time'}
                                    direction={orderBy === 'punch_time' ? order : 'asc'}
                                    onClick={() => handleRequestSort('punch_time')}
                                >
                                    Punch Time
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Address</TableCell>
                            <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>Latitude</TableCell>
                            <TableCell align="center" className="table-header" style={{ minWidth: '120px' }}>Longitude</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {paginatedRows.map((row) => {
                            return(
                                <TableRow key={row.request_id}>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.stop_id}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', fontWeight:'500' }}>{row.name}</Typography></TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                            {`${row.stop_status?.toUpperCase()}${row.is_auto_arrived ? ' (Auto)' : ''}`}
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                            {row.punch_time ? 
                                                (() => {
                                                const pickupDate = new Date(row.punch_time.replace(" ", "T") + "Z");
                                                // Add the offset minutes to the date
                                                pickupDate.setMinutes(pickupDate.getMinutes() + utcOffset);
                                                return pickupDate.toLocaleString('en-GB', {
                                                    day: '2-digit', 
                                                    month: '2-digit', 
                                                    year: 'numeric', 
                                                    hour: '2-digit', 
                                                    minute: '2-digit', 
                                                    hour12: timeZoneFormat == '12' ? true : false,
                                                    timeZone: 'UTC'
                                                }).replace(',', ' |');
                                                })() 
                                                : '--'
                                            }
                                        </Typography>
                                    </TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '180px' }}>{row.address}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '180px' }}>{row.latitude}</Typography></TableCell>
                                    <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '180px' }}>{row.longitude}</Typography></TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
                <div className="custom-pagination">
                    <div className="pagination-info">
                        {(() => {
                            const total = rows.length;
                            if (total === 0) return `Showing 0 to 0 of 0 entries`;
                            const start = page * rowsPerPage + 1;
                            const end = Math.min((page + 1) * rowsPerPage, total);
                            return `Showing ${start} to ${end} of ${total} entries`;
                        })()}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>
        </div>
    )
}
export default Tab3Details;